module.exports = __webpack_public_path__ + "assets/img/23091a33715fd545d3295321c138ea69.png";